import React from "react";
import { useIntl } from "react-intl";
import Icon from "@Components/Icon";
import fieldClasses from "./BookFormModalField.module.scss";
import { cdnImageUrl } from "@Src_main/utils/generalUtils";
var BookFormField = _ref => {
  var {
    fieldLabel,
    fieldIcon,
    fieldIconSpinner,
    fieldImg,
    fieldId,
    minimalView,
    fieldTextWhenEmpty,
    fieldSecondaryTextWhenEmpty,
    backgroundClass,
    borderClass,
    fieldSelected,
    applySelectedClasses,
    fieldSelectedExtraInfo,
    explainInfo,
    fieldSelectedSecondaryInfo,
    isFieldComplete = !!fieldSelected,
    openModal,
    disabled,
    hidden,
    modalComponent: ModalComponent,
    modalProps,
    shakeOnIncomplete = true
  } = _ref;
  var {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(React.Fragment, null, fieldLabel && !hidden ? /*#__PURE__*/React.createElement("div", {
    className: "uk-text-small uk-margin-remove-top uk-margin-small-bottom "
  }, fieldLabel) : null, /*#__PURE__*/React.createElement("div", {
    field: fieldId,
    onClick: () => {
      if (!disabled) openModal();
    },
    className: "weglotExclude ".concat(isFieldComplete || disabled || applySelectedClasses ? "" : "uk-border-red-input", " ").concat(fieldClasses.Selector, " ").concat(backgroundClass ? backgroundClass : "", " ").concat(borderClass ? borderClass : "", " ").concat(fieldSelected || applySelectedClasses ? fieldClasses.selected : "", " ").concat(disabled ? fieldClasses.disabled : "", " ").concat(shakeOnIncomplete && !isFieldComplete ? "shake-incomplete" : "", " ").concat(minimalView ? fieldClasses.minimalView : "uk-box-shadow-medium"),
    style: hidden ? {
      display: "none"
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: fieldClasses.selectorMedia
  }, fieldIconSpinner ? /*#__PURE__*/React.createElement("div", {
    "uk-spinner": "ratio: 2",
    style: {
      padding: "13px 15px"
    }
  }) : fieldImg && !minimalView ? /*#__PURE__*/React.createElement("img", {
    width: "50px",
    src: cdnImageUrl(fieldImg),
    alt: ""
  }) : /*#__PURE__*/React.createElement(Icon, {
    className: "uk-padding-small uk-flex-center",
    style: fieldId === "quantity" ? {
      fontWeight: "bold"
    } : {},
    name: fieldIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: fieldClasses.selectorText
  }, /*#__PURE__*/React.createElement("div", {
    className: fieldClasses.selectorTitleRow
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-text-secondary uk-text-small uk-text-bold ".concat(fieldClasses.selectorTitle)
  }, isFieldComplete ? fieldSelected : fieldTextWhenEmpty), isFieldComplete && fieldSelectedExtraInfo ? /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-row uk-margin-small-left"
  }, fieldSelectedExtraInfo) : null), isFieldComplete && fieldSelectedSecondaryInfo ? /*#__PURE__*/React.createElement("div", {
    className: "uk-text-secondary uk-text-xsmall ".concat(fieldClasses.selectorSubtitle)
  }, fieldSelectedSecondaryInfo) : null, !isFieldComplete && disabled && fieldSecondaryTextWhenEmpty ? /*#__PURE__*/React.createElement("div", {
    className: "uk-text-muted uk-text-xsmall ".concat(fieldClasses.selectorSubtitle)
  }, fieldSecondaryTextWhenEmpty) : null), !disabled ? /*#__PURE__*/React.createElement("div", {
    className: fieldClasses.selectorPrompt
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("u", null, formatMessage({
    id: "Modifica"
  })))) : null), explainInfo && !isFieldComplete ? /*#__PURE__*/React.createElement("div", {
    className: "uk-text-muted uk-text-xsmall"
  }, explainInfo) : null, !disabled && ModalComponent ? /*#__PURE__*/React.createElement(ModalComponent, modalProps) : null);
};
export default BookFormField;